import { useEffect, useRef } from 'react';
import { PythiaSDK } from '@pythiasport/betting-widget';

import './racebook.css';

export const BettingWidget = ({
    currencyCode,
    tenantId,
    userId,
    token,
    url,
    language,
    clientIdForWidgets,
}) => {
    const sdkRef = useRef(PythiaSDK);

    useEffect(() => {
        const sdk = new PythiaSDK();
        sdkRef.current = sdk;

        sdk.on('betslip:open', () => {
            console.log('Betslip opened');
        });

        let initVar = {
            tenantId,
            jwtToken: token,
            userId,
            currencyCode,
            currencySymbol: '',
            theme: 'light',
            bettingAppUrl: url,
            language,
            clientIdForWidgets,
        };
        // console.log('INIT', initVar)
        if (url && token && tenantId && userId && currencyCode) {
            sdk.init(initVar);
        }

        return () => {
            sdk.destroy();
        };
    }, [url]);

    return (
        <div>
            {/* <button onClick={() => sdkRef.current?.setTheme('light')}>Toggle Theme</button> */}
            <div id="betting-widget-container" />
        </div>
    );
};
